import { render, staticRenderFns } from "./CombinationTradeData.vue?vue&type=template&id=585a9902&"
import script from "./CombinationTradeData.vue?vue&type=script&lang=js&"
export * from "./CombinationTradeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports